<template>
  <div v-if="source" class="provider-main-image-wrapper">
    <img alt="Provider logo" class="provider-main-image" :src="source">
  </div>
</template>

<style scoped>
  .provider-main-image-wrapper {
    border-radius: 2px;
    position: relative;
    top: -90px;
    right: 16px;
    margin-left: auto;
    width: 75px;
    height: 75px;
    border: 1px solid #dfe2e9;
    background-color: #ffffff;
    padding: 8px;
    border-radius: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .provider-main-image {
    border-radius: 2px;
    width: 100%;
    height: 100%;
    object-fit: contain;
    background-color: #ffffff;
  }
</style>

<script>
export default {
  name: 'provider-list-item-logo',
  props: {
    source: {
      required: true,
    },
  },
};
</script>
